// extracted by mini-css-extract-plugin
module.exports = {"pageIntro":"index-module--pageIntro--dztHh","pageIntroRibbon":"index-module--pageIntroRibbon--2xrCq"};